import assetPath from '/app/xinglets/upsell/campaign-page/src/assets/amex.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')